import { action, atom, reatomSet } from "@reatom/framework";
import { ProductSelectionDto } from "definitions/product-storage/models/product-selection-dto";
import { withDebounce } from "src/common/pipes";

const selectedIdsAtom = reatomSet<number>();

const currentSelectionAtom = atom<ProductSelectionDto | null>(
  null,
  "currentSelection",
);

const selectedArrayAtom = atom(
  (ctx) => Array.from(ctx.spy(selectedIdsAtom)),
  "selectedArray",
);

const selectedJsonAtom = atom(
  (ctx) => JSON.stringify(ctx.spy(selectedArrayAtom), null, 2),
  "selectedJson",
);

const setSelectedIdsAction = action((ctx, input: number[]) => {
  const spuIds = new Set(input);
  selectedIdsAtom(ctx, spuIds);
});

const addSelectedIdsAction = action((ctx, spuIds: number[]) => {
  const selectedSet = ctx.get(selectedIdsAtom);
  spuIds.forEach((id) => selectedSet.add(id));
  selectedIdsAtom(ctx, selectedSet);
});

const setCurrentSelectionAction = action(
  (ctx, selection: ProductSelectionDto | null) => {
    currentSelectionAtom(ctx, selection);
    if (selection) {
      setSelectedIdsAction(ctx, selection.productIds || []);
    }
  },
);

const clearSelectionAction = action((ctx) => {
  currentSelectionAtom(ctx, null);
  selectedIdsAtom(ctx, new Set());
});

const setSelectedIdsActionWithDebounce = setSelectedIdsAction.pipe(
  withDebounce(200),
);

export const productSelectionStore = {
  selectedIdsAtom,
  currentSelectionAtom,
  selectedArrayAtom,
  selectedJsonAtom,
  setSelectedIdsAction,
  setSelectedIdsActionWithDebounce,
  addSelectedIdsAction,
  setCurrentSelectionAction,
  clearSelectionAction,
};
